import React, { useState, useMemo } from 'react';
import { Offcanvas, Form, Button } from 'react-bootstrap';
import { FiSearch } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

interface Brand {
    name: string;
    autologin_url: string;
}

interface BrandsMenuProps {
    show: boolean;
    onHide: () => void;
    brands: Brand[];
}

const BrandsMenu: React.FC<BrandsMenuProps> = ({ show, onHide, brands }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedBrand, setSelectedBrand] = useState<Brand | null>(null);
    const navigate = useNavigate();

    // Filter brands based on search term
    const filteredBrands = useMemo(() => {
        if (!searchTerm) return brands;
        const searchLower = searchTerm.toLowerCase();
        return brands.filter(brand =>
            brand.name.toLowerCase().includes(searchLower)
        );
    }, [brands, searchTerm]);

    const handleBrandClick = (brand: Brand) => {
        // Update localStorage with the selected brand's autologin URL
        localStorage.setItem('autologinUrl', brand.autologin_url);
        setSelectedBrand(brand);
        onHide();
        navigate("/dashboard")
        // Optional: Close the menu after selection
        // onHide();
    };

    return (
        <Offcanvas
            show={show}
            onHide={onHide}
            placement="end"
            style={{ width: '350px' }}
        >
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>Brands</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="p-0 d-flex flex-column">
                {/* Search Bar */}
                <div className="p-3 border-bottom">
                    <div className="position-relative">
                        <Form.Control
                            type="text"
                            placeholder="Search brands..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="ps-5"
                        />
                        <FiSearch
                            className="position-absolute"
                            style={{ left: '15px', top: '18px', color: '#6c757d' }}
                        />
                    </div>
                </div>

                {/* Brands List */}
                <div
                    style={{
                        maxHeight: 'calc(100vh - 200px)',
                        overflowY: 'auto',
                        padding: '0.5rem'
                    }}
                >
                    {filteredBrands.map((brand, index) => (
                        <Button
                            key={index}
                            variant="outline-secondary"
                            className={`w-100 text-start mb-2 ${selectedBrand?.autologin_url === brand.autologin_url ? 'active' : ''}`}
                            onClick={() => handleBrandClick(brand)}
                            style={{
                                textAlign: 'left',
                                padding: '0.75rem 1rem',
                                border: '1px solid #dee2e6',
                                background: selectedBrand?.autologin_url === brand.autologin_url
                                    ? '#f8f9fa'
                                    : 'white',
                                color: '#212529',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                                whiteSpace: 'normal',
                                height: 'auto',
                                minHeight: '45px'
                            }}
                        >
                            <div
                                style={{
                                    width: '100%',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                }}
                            >
                                {brand.name}
                            </div>
                            {/* <small className="text-muted" style={{
                                fontSize: '0.8rem',
                                color: '#6c757d',
                                width: '100%',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                            }}>
                                {new URL(brand.autologin_url).hostname}
                            </small> */}
                        </Button>
                    ))}

                    {filteredBrands.length === 0 && (
                        <div className="text-center py-4 text-muted">
                            No brands found
                        </div>
                    )}
                </div>

                {/* Selected Brand Info */}
                {/* {selectedBrand && (
                    <div className="mt-auto p-3 border-top">
                        <div className="d-flex justify-content-between align-items-center">
                            <div>
                                <h6 className="mb-1">{selectedBrand.name}</h6>
                                <small className="text-muted">
                                    {new URL(selectedBrand.autologin_url).hostname}
                                </small>
                            </div>
                            <Button
                                variant="primary"
                                size="sm"
                                onClick={() => {
                                    window.open(selectedBrand.autologin_url, '_blank');
                                }}
                            >
                                Open
                            </Button>
                        </div>
                    </div>
                )} */}
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default BrandsMenu;
